/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Postal_CodeInputs */

const en_orders_postal_code = /** @type {(inputs: Orders_Postal_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postal Code`)
};

const es_orders_postal_code = /** @type {(inputs: Orders_Postal_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codigo postal`)
};

/**
* | output |
* | --- |
* | "Postal Code" |
*
* @param {Orders_Postal_CodeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_postal_code = /** @type {((inputs?: Orders_Postal_CodeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Postal_CodeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_postal_code(inputs)
	return es_orders_postal_code(inputs)
});